import React, { useEffect, useState } from "react";
import { Trophy, Medal, Award } from "lucide-react";

const premiumStyles = {
  container: {
    backgroundColor: "#1e293b",
    borderRadius: "24px",
    boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.3)",
    border: "1px solid rgba(255, 255, 255, 0.05)",
    padding: "32px 34px",
    maxWidth: 800,
    margin: "0 auto",
  },
  title: {
    fontWeight: 800,
    color: "#f8fafc",
    fontSize: "1.75rem",
    marginBottom: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
    letterSpacing: "-0.5px"
  },
  list: {
    listStyleType: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    flexDirection: "column",
    gap: "12px"
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#0f172a",
    border: "1px solid rgba(255, 255, 255, 0.03)",
    borderRadius: "16px",
    padding: "16px 24px",
    transition: "transform 0.2s ease, background-color 0.2s ease",
  },
  name: {
    fontWeight: 600,
    fontSize: "1.1rem",
    color: "#e2e8f0",
    flexGrow: 1,
    marginLeft: "16px"
  },
  badge: {
    backgroundColor: "rgba(251, 191, 36, 0.1)",
    color: "#fbbf24",
    borderRadius: "12px",
    fontWeight: 700,
    fontSize: "1.05rem",
    padding: "8px 16px",
    minWidth: "80px",
    textAlign: "center",
    letterSpacing: "1px",
    border: "1px solid rgba(251, 191, 36, 0.2)"
  },
  loading: {
    color: "#94a3b8",
    fontSize: "1.1rem",
    textAlign: "center",
    margin: "40px 0",
    fontStyle: "italic"
  },
};

export default function TopMembri() {
  const [topMembers, setTopMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://prdp-api.suport-949.workers.dev/api/membri", {
      headers: { Authorization: "Bearer unwantedtok" },
    })
      .then(res => res.json())
      .then(data => {
        const sorted = data.sort((a, b) => b.puncte - a.puncte).slice(0, 10);
        setTopMembers(sorted);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  // Funcție pentru a genera un icon special pentru Top 3
  const renderRankIcon = (index) => {
    if (index === 0) return <Trophy size={28} color="#fbbf24" style={{ filter: "drop-shadow(0 0 8px rgba(251,191,36,0.6))" }} />; // Aur
    if (index === 1) return <Medal size={26} color="#cbd5e1" />; // Argint
    if (index === 2) return <Award size={26} color="#b45309" />; // Bronz
    
    return (
      <div style={{
        width: "28px", height: "28px", borderRadius: "50%", 
        backgroundColor: "#1e293b", color: "#64748b",
        display: "flex", alignItems: "center", justifyContent: "center",
        fontWeight: 700, fontSize: "0.9rem"
      }}>
        {index + 1}
      </div>
    );
  };

  if (loading) return <div style={premiumStyles.loading}>Se încarcă clasamentul...</div>;

  return (
    <div style={premiumStyles.container}>
      <div style={premiumStyles.title}>
        <Trophy color="#fbbf24" size={32} /> Clasament Național
      </div>
      <ul style={premiumStyles.list}>
        {topMembers.map(({ id, prenume, nume, puncte }, idx) => (
          <li 
            key={id} 
            style={premiumStyles.listItem}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateX(5px)";
              e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.05)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateX(0)";
              e.currentTarget.style.backgroundColor = "#0f172a";
            }}
          >
            <div style={{ minWidth: "40px", display: "flex", justifyContent: "center" }}>
              {renderRankIcon(idx)}
            </div>
            
            <span style={premiumStyles.name}>{prenume} {nume}</span>
            
            <span style={premiumStyles.badge}>
              {puncte.toLocaleString('ro-RO')} pts
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
}
